import * as React from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { processFetchingDashboardDetails } from "../redux-store/dashboardSlice/dashboardSliceActions"
import { IntroVideoBlock } from '../components/Dashboard/IntroVideoBlock';
import { TopBanner } from '../components/Dashboard/TopBanner';
import { styled } from '@mui/material';
import { useScrollToTop } from '../hooks/useScrollToTop';


const DashboardWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    background: "#ffffff",
    overflow: "auto",
    "& .image-gallery-image": {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
    },
    '& video': {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
    },
    [theme.breakpoints.down('md')]: {
        background: "#fafafa",
    },
}));

const ContentSection = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3, 3),
    maxWidth: '1400px',
    margin: '0 auto',
    width: '100%',
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(0),
    },
}));


const Dashboard = () => {
    const dispatch = useDispatch()

    useScrollToTop()

    React.useEffect(() => {
        dispatch(processFetchingDashboardDetails())
    }, [dispatch])

    return (
        <DashboardWrapper>
            <TopBanner />
            <ContentSection>

                {/* Video Introduction Section */}
                <Box width="100%">
                    <IntroVideoBlock />
                </Box>
            </ContentSection>
        </DashboardWrapper>
    );
};


export default Dashboard;
